import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AlertService } from '../_services/alert.service';

export interface ApiErrorResponse {
  message: string;
  code: string;
  details?: string;
}

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const alertService = inject(AlertService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let message = 'Unexpected error occurred.';

      if (error.error) {
        if (typeof error.error === 'string') {
          message = error.error;
        } else if (error.error.message) {
          message = error.error.message;
          if (error.error.details?.length > 0) {
            message += '\r\n' + error.error.details;
          }
        }
      } else if (error.message) {
        message = error.message;
      }

      alertService.error(message);

      return throwError(() => error);
    })
  );
};
